var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menu'),_c('RouteStepper',{attrs:{"steps":_vm.steps}}),_c('GroupTablesComponent',{attrs:{"timeline":_vm.filteredTimeline,"client":_vm.client,"refreshClient":_vm.refreshClient,"accountView":_vm.accountView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }